import { MOKA_OPEN_API_HOST } from 'api/constants';

export const V1_AUTHORIZED_APPS_URL = ({ userId }) =>
  `${MOKA_OPEN_API_HOST}/v1/users/${userId}/authorized_apps`;

export const V1_AUTHORIZED_APP_BY_ID = ({ userId, appId }) =>
  `${MOKA_OPEN_API_HOST}/v1/users/${userId}/authorized_apps/${appId}`;
